/**
 * Context for offline POS state (desktop app only).
 * Provides pending bill count and sync actions for the sync indicator.
 */

import React, { createContext, useContext } from 'react';

export const OfflineContext = createContext({
  pendingCount: 0,
  isSyncing: false,
  syncNow: () => {},
  refreshPendingCount: () => {},
  fetchPendingOrders: () => Promise.resolve([])
});

export function useOffline() {
  return useContext(OfflineContext);
}
